import { render, staticRenderFns } from "./SampleClassificationNoise.vue?vue&type=template&id=68e02bfa&scoped=true"
import script from "./SampleClassificationNoise.vue?vue&type=script&lang=js"
export * from "./SampleClassificationNoise.vue?vue&type=script&lang=js"
import style0 from "./SampleClassificationNoise.vue?vue&type=style&index=0&id=68e02bfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e02bfa",
  null
  
)

export default component.exports